/** Tiny DOM helpers for the meta UI kit (re-exports the HUD's `el`). */
export { el, onPress } from '../../hud/dom';

/** Parse a static SVG/HTML string we authored ourselves into one element. */
export function svg(markup: string): SVGSVGElement {
  const t = document.createElement('template');
  t.innerHTML = markup.trim();
  return t.content.firstElementChild as SVGSVGElement;
}

/** Remove every child of an element. */
export function clear(e: Element): void {
  while (e.firstChild) e.removeChild(e.firstChild);
}

/** Roman numerals for sub-ranks (1..10). */
export function roman(n: number): string {
  return ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'][n] ?? String(n);
}

/** "1,234" grouping without locale surprises. */
export function groupNumber(n: number): string {
  const s = String(Math.round(Math.abs(n)));
  const out = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return n < 0 ? `-${out}` : out;
}

/** "+12" / "−4" / "±0" for deltas. */
export function signed(n: number, digits = 0): string {
  const v = Number(n.toFixed(digits));
  if (v > 0) return `+${v.toFixed(digits)}`;
  if (v < 0) return `−${Math.abs(v).toFixed(digits)}`;
  return `±0`;
}
